const main = () => {
    if(document.querySelector('.c-others-hamburger') === null) return;

    document.querySelectorAll('[data-open-hamburger]').forEach(button => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector(".l-header").toggleAttribute("data-active")
            button.toggleAttribute("data-active")
            document.querySelector('.c-others-hamburger').toggleAttribute("data-active")
        });
    });
}

export default main
